import JourneyEpics from './journey.epic';
import OrganizationEpics from './organization.epic';

const CustomizationEpics = [
  ...JourneyEpics,
  ...OrganizationEpics,
];

export default CustomizationEpics;
